import Head from 'next/head'
import React from 'react'
import {
  fnoSeoDetailbreadCrumbList,
  seoDataDetail,
  seoDetailbreadCrumbList,
} from '../utils'
import SEOHeader, { SEOProps } from '@/components/Common/SEOHeader'
import BreadCrumb from '@/stories/components/Common/BreadCrumbs'
import BackNavigation from '@/stories/components/Common/BackNavigation'
import {
  IndexMetaData,
  StockSchemaData,
} from '@/components/Stocks/Widgets/types'

const SEODetail = (props: {
  name?: string
  symbol?: string
  entity_class?: string
  relativepath?: string
  short_name?: string
  isFnO?: boolean
  host?: string
  metaData?: IndexMetaData
  stockSchemaData?: StockSchemaData
  isGlobal?: boolean
  useShortName?: boolean
  strapiSeoData?: SEOProps['data'] | null
}) => {
  const {
    name,
    symbol = '',
    entity_class,
    relativepath,
    short_name,
    isFnO = false,
    metaData,
    stockSchemaData,
    isGlobal = false,
    useShortName = false,
    strapiSeoData,
  } = props

  const seoData = seoDataDetail({
    name,
    symbol,
    entity_class,
    relativepath,
    short_name: short_name ?? name,
    metaData,
    stockSchemaData,
    isGlobal,
    useShortName,
  })

  const finalSchemas = [...(strapiSeoData?.schemas ?? []), ...seoData.schemas]
  const combinedSeoData = {
    title: strapiSeoData?.title ?? seoData.title,
    description: strapiSeoData?.description ?? seoData.description,
    keywords: strapiSeoData?.keywords ?? seoData.keywords,
    canonicalUrl: strapiSeoData?.canonicalUrl ?? seoData.canonicalUrl,
    schemas: finalSchemas,
  }

  return (
    <>
      <SEOHeader data={combinedSeoData} noIndexNoFollow={isFnO} />
      <Head>
        <link rel="pre-connect" href="//indcdn.indmoney.com" />
      </Head>
      <BackNavigation link={isFnO ? '/futures-and-options' : '/stocks'}>
        <BreadCrumb
          breadCrumbList={
            isFnO
              ? fnoSeoDetailbreadCrumbList(name, props.host)
              : seoDetailbreadCrumbList(
                  name,
                  entity_class,
                  props.host,
                  isGlobal,
                  useShortName,
                  short_name ?? name,
                )
          }
        />
      </BackNavigation>
    </>
  )
}

export default SEODetail
